<div class="page">
  <div class="toolbar">
    <div><div class="eyebrow">Medical assistant</div><h2>Assistant dashboard</h2><div class="small">Create, search, edit, delete patients, and enter investigation results.</div></div>
    <div style="margin-left:auto" class="toolbar"><button (click)="logout()">Logout</button></div>
  </div>

  <div class="section panel">
    <div class="grid grid-2">
      <div><label>Search patients</label><input [(ngModel)]="query" placeholder="ID, name, phone, email, address"></div>
      <div style="display:flex;align-items:end"><button (click)="search()">Search</button></div>
    </div>
    <div class="card-list section">
      <div class="card-item" *ngFor="let p of patients">
        <div><b>{{ p.full_name }}</b> <span class="small">({{ p.patient_code }})</span></div>
        <div class="small">{{ p.phone }} | {{ p.email }} | {{ p.address }}</div>
        <div class="toolbar" style="margin-top:8px">
          <button (click)="select(p)">Edit</button>
          <button (click)="deletePatient(p)">Delete</button>
          <a class="link" [routerLink]="['/patients', p.id]">Detail</a>
        </div>
      </div>
    </div>
  </div>

  <div class="section panel">
    <h3>{{ selected ? 'Edit patient' : 'Create patient' }}</h3>
    <div class="grid grid-2">
      <div><label>Patient code</label><input [(ngModel)]="form.patient_code"></div>
      <div><label>Assign doctor</label>
        <select [(ngModel)]="form.assigned_doctor_id">
          <option [ngValue]="null">Select doctor</option>
          <option *ngFor="let d of doctors" [ngValue]="d.id">{{ d.name }}</option>
        </select>
      </div>
      <div><label>Full name</label><input [(ngModel)]="form.full_name"></div>
      <div><label>Age</label><input type="number" [(ngModel)]="form.age"></div>
      <div><label>Sex</label><input [(ngModel)]="form.sex"></div>
      <div><label>Phone</label><input [(ngModel)]="form.phone"></div>
      <div><label>Email</label><input [(ngModel)]="form.email"></div>
      <div><label>Address</label><input [(ngModel)]="form.address"></div>
      <div><label>Occupation</label><input [(ngModel)]="form.occupation"></div>
    </div>
    <div class="toolbar section"><button (click)="savePatient()">Save patient</button></div>
  </div>

  <div class="section panel" *ngIf="selected">
    <h3>Investigation result entry</h3>
    <label>Status</label>
    <select [(ngModel)]="resultStatus">
      <option value="pending">pending</option>
      <option value="normal">normal</option>
      <option value="abnormal">abnormal</option>
      <option value="critical">critical</option>
    </select>
    <label>Result text</label>
    <textarea [(ngModel)]="investigationResult"></textarea>
    <div class="toolbar"><button (click)="saveInvestigationResult()">Save result</button></div>
  </div>
</div>
